import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { dexfSettingsQueryOptions, rangeDataQueryOptions } from '@/query-options'
import { getLocaleFromPath } from '@/utils/base-path-params'
import { getConfigurationFromDesignCodeOrRedirectHome } from '@/utils/get-configuration-from-design-code'
import { redirectHome, redirectToScene } from '@/utils/redirects'

const pathParamsSchema = z.object({
  country: z.string().length(2),
  language: z.string().length(2),
  code: z.string().min(6).max(9, 'Invalid design code'),
})

export const Route = createFileRoute('/$country/$language/$mode/design/$code')({
  beforeLoad: async ({ context, params }) => {
    const { code } = params
    if (!code) {
      throw new Error('Missing design code')
    }

    const dexfSettings = await context.queryClient.ensureQueryData(dexfSettingsQueryOptions(getLocaleFromPath()))
    const rangeData = await context.queryClient.ensureQueryData(rangeDataQueryOptions(dexfSettings))

    if (pathParamsSchema.safeParse({ ...params }).success) {
      const design = await getConfigurationFromDesignCodeOrRedirectHome(dexfSettings, code, context.insightsApi)
      const potentialItem = design?.itemList?.[0]
      if (!potentialItem) throw redirectHome(Route.fullPath)
      const potentialSofaId = potentialItem.id
      const sofa = Object.values(rangeData)
        .flatMap((r) => r.sofas)
        .find((sofa) => sofa.itemNo === potentialSofaId || sofa.productData.content.itemNoLocal === potentialSofaId)
      if (!sofa) {
        throw redirectHome(Route.fullPath)
      }
      throw redirectToScene(Route.fullPath, sofa.rangeId, sofa.itemNo)
    }

    throw redirectHome(Route.fullPath)
  },
})
